import React from 'react';
import {useStores} from "../../../stores/Context";
import {observer} from "mobx-react";
import ParametresGeneral from "./ParametresGeneral";
import ParametresGestionEquipes from "./ParametresGestionEquipes";
import ParametresObjectifs from "./ParametresObjectifs";


const ParametresHome = observer (() => {

    const {parametresStore, uiStore} = useStores();

    const handleViewGeneralBtn = () => {
        parametresStore.handleViewGeneral();
    }

    const handleViewEquipesBtn = () => {
        parametresStore.handleViewEquipes();
    }

    const handleViewObjectifsBtn = () => {
        parametresStore.handleViewObjectifs();
    }

    const handleGoHome = (event) => {
        event.preventDefault();
        uiStore.closeConsultingIndicateurWidget();
    }

    return (
        <div className={"parametreBody"}>

            {
                /*
                <div className={"parametreHeader"}>
                <div onClick={handleGoHome}>
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 10L31.2903 31.2903" stroke="#002335" stroke-width="4" stroke-linecap="round"
                              stroke-linejoin="round"/>
                        <path d="M10 31.291L31.2903 10.0007" stroke="#002335" stroke-width="4" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
                 */
            }

            <span className={"parametreTitre"}>Paramètres</span>

            <ParametresGeneral/>

            <ParametresGestionEquipes/>

            {
                /*
                <ParametresObjectifs/>
                 */
            }

        </div>
    );
});

export default ParametresHome;